import ruLocale from 'date-fns/locale/ru';

const getDomain = (): string =>
  process.env.REACT_APP_DOMAIN
    ? process.env.REACT_APP_DOMAIN
    : window.location.hostname;

export const Constants = {
  ServerProtocol: 'https',
  ServerDomain: getDomain(),
  ApiBasePath: '/api',
  AuthSignInPath: '/login',
  AuthLogoutPath: '/logout',
  AuthLogoutAllSessionsPath: '/logout-all-sessions',
  AuthRefreshTokensPath: '/refresh-tokens',
  RefreshTokenKey: 'refresh_token',
  CredentialsExpBeforeSec: 10,
  EmailLengthMax: 50,
  PasswordLengthMin: 8,
  UserFullNameLengthMax: 100,
  UserNickNameLengthMax: 50,
  NameLengthMin: 3,
  NameLengthMax: 200,
  DescriptionLengthMax: 150,
  itemsPerPage: 10,
  locale: ruLocale,
  mapApiKey: '2aec7e6a-85b9-47a0-bb5d-31de6f6b5c69',
  mapCenterDefault: [45.279413, 34.193864],
  mapZoomDefault: 8,
  mapZoomAppeal: 15,
  statusCodeRejected: 'rejected',
  statusCodeExecution: 'execution',
  statusCodeApproval: 'approval',
  statusCodeDeflected: 'deflected',
  statusCodeHold: 'hold',
  statusCodeConfirm: 'confirm',
  userRole: 'ROLE_USER',
  moderatorRole: 'ROLE_MODERATOR',
  coordinatorRole: 'ROLE_COORDINATOR',
  executorRole: 'ROLE_EXECUTOR',
  directorRole: 'ROLE_DIRECTOR',
  adminRole: 'ROLE_ADMIN',
  mainPageId: 1,
  aboutPageId: 2,
  tabKey: 'activeTab',
  acceptedText: 'Решение проблемы подтверждено гражданином',
  dateFormat: 'DD.MM.YYYY',
};

export default Constants;
